<template>
<fieldset>
  <legend>{{ labels[shared.lang].chocomint_info }} {{ item&&item.idx>0?labels[shared.lang].edit:labels[shared.lang].add }}</legend>
  
  <form v-if="item" @submit.prevent="submit">
    <div class="form-group row justify-content-end">
      <label for="inputNameJa" class="col-sm-2 col-form-label text-sm-right" v-text="labels[shared.lang].form_name"></label>
      <div class="col-sm-10 col-md-5">
        <input type="text" class="form-control" id="inputNameJa" :placeholder="labels[shared.lang].form_name_ja" required v-model.trim="item.name_ja">
      </div>
      <div class="col-sm-10 col-md-5 mt-2 mt-md-0" v-if="shared.lang=='ko'">
        <input type="text" class="form-control" id="inputNameKo" :placeholder="labels[shared.lang].form_name_ko" v-model.trim="item.name_ko">
      </div>
    </div>
    <div class="form-group row justify-content-end">
      <label for="inputOffice" class="col-sm-2 col-form-label text-sm-right" v-text="labels[shared.lang].form_office"></label>
      <div class="col-sm-10 col-md-5">
        <input type="text" class="form-control" id="inputOffice" :placeholder="labels[shared.lang].form_office_ja" v-model.trim="item.office">
        <select class="form-control mt-1" v-model="offices.ja_select" @change="changeOfficeJa(offices.ja_select)">
          <option value="" disabled v-text="labels[shared.lang].form_office_select"></option>
          <option v-for="off in offices.ja_list" v-text="off" :value="off"></option>
        </select>
      </div>
      <div class="col-sm-10 col-md-5 mt-2 mt-md-0" v-if="shared.lang=='ko'">
        <input type="text" class="form-control" id="inputNameKo" :placeholder="labels[shared.lang].form_office_ko" v-model.trim="item.office_ko">
        <select class="form-control mt-1" v-model="offices.ko_select" @change="changeOfficeKo(offices.ko_select)">
          <option value="" disabled v-text="labels[shared.lang].form_office_select"></option>
          <option v-for="off in offices.ko_list" v-text="off" :value="off"></option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputImageUrl" class="col-sm-2 col-form-label text-sm-right" v-text="labels[shared.lang].form_profile_url"></label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="inputImageUrl" :placeholder="labels[shared.lang].form_profile_url" v-model.trim="item.image_url">
        <p class="text-muted mb-0" v-text="labels[shared.lang].form_profile_comment"></p>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputStatus" class="col-sm-2 col-form-label text-sm-right" v-text="labels[shared.lang].chocomint"></label>
      <div class="col-sm-10">
        <select id="inputStatus" class="form-control" v-model.number="item.status">
          <option value="0" disabled v-text="labels[shared.lang].chocomint_info"></option>
          <option value="1" v-text="labels[shared.lang].filter1"></option>
          <option value="2" v-text="labels[shared.lang].filter2"></option>
          <option value="4" v-text="labels[shared.lang].filter4"></option>
          <option value="3" v-text="labels[shared.lang].filter3"></option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputMemo" class="col-sm-2 col-form-label text-sm-right" v-text="labels[shared.lang].form_memo"></label>
      <div class="col-sm-10">
        <textarea class="form-control" id="inputMemo" cols="60" rows="4" :placeholder="labels[shared.lang].form_memo" v-model.trim="item.memo"></textarea>
        <p class="text-muted mb-0" v-text="labels[shared.lang].form_memo_comment"></p>
      </div>
    </div>
    <div class="form-group row" v-if="shared.user.idx == 1">
      <div class="col-sm-10">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="1" id="adminCheck" v-model.trim="item.admin_mode">
          <label class="form-check-label" for="adminCheck">관리자 모드</label>
        </div>
      </div>
    </div>
    <div class="form-group row form-btn-group justify-content-end">
      <div class="col-sm-10 d-flex justify-content-between">
        <button type="submit" class="btn btn-info" :disabled="loading">{{ loading ? labels[shared.lang].form_adding : labels[shared.lang].form_add }}</button>
        <button type="button" class="btn btn-danger" :disabled="loading" @click.prevent="remove(item.idx)" v-text="labels[shared.lang].remove"></button>
      </div>
    </div>
  </form>
  
</fieldset>
</template>

<script>
'use strict'
import axios from 'axios'
import { labels } from '../label.js'
import { shared } from '../state.js'
axios.defaults.withCredentials = true

export default {
  name: 'FormCtrl',
  data() {
    return {
      labels: labels,
      shared: shared,
      
      offices: {ja_list: null, ko_list: null, ja_select: '', ko_select: ''},
      item: null,
      loading: false,
    }
  },
  created() {
    this.initSocialTag()
    if(!shared.user) {
      document.location.href = '/'
      return
    }
    axios.get(`${shared.apiroot}1.1/offices`).then((resp2)=> {
      this.offices.ja_list = resp2.data.offices
      this.offices.ko_list = resp2.data.office_kos
      this.init()
    }).catch(()=>{ document.location.href = '/' })
  },
  methods: {
    init() {
      if(this.$route.params && this.$route.params.idx) {
        axios.get(`${shared.apiroot}1.1/detail/${this.$route.params.idx}`).then((resp)=> {
          if(resp.data.item) {
            resp.data.item.image_url = '' // remove image url for only add
            this.item = resp.data.item
          }
          else {
            document.location.href = '/'
          }
        }).catch(()=> {
          document.location.href = '/'
        })
      }
      else {
        this.item = {status:0}
      }
    },
    changeOfficeJa(value) {
      if(!this.item) return
      this.item.office = value
      this.offices.ja_select = ''
    },
    changeOfficeKo(value) {
      if(!this.item) return
      this.item.office_ko = value
      this.offices.ko_select = ''
    },
    submit() {
      if(!this.item.name_ja) return alert(labels[shared.lang].form_err_name)
      if(this.item.status < 1) return alert(labels[shared.lang].form_err_chocomint)
      if(!confirm(labels[shared.lang].form_confirm)) return
      
      this.loading = true
      axios.post(`${shared.apiroot}1.1/update`, this.item).then((resp)=> {
        this.loading = false
        if(!resp || !resp.data) return alert(labels[shared.lang].error)
        if(resp.data.result == -1) return alert(labels[shared.lang].form_err_login)
        if(resp.data.result == 1) return alert(labels[shared.lang].form_err_required)
        if(resp.data.result == 2) return alert(labels[shared.lang].form_err_duplicate)
        
        alert(labels[shared.lang].form_success)
        if(this.item && this.item.idx > 0) this.$router.replace('/details/' + this.item.idx)
        else this.$router.replace('/')
        
      }).catch(() => {
        this.loading = false
        alert(labels[shared.lang].error)
      })
    },
    remove(idx) {
      if(!confirm(labels[shared.lang].form_remove_confirm)) return
      
      axios.post(`${shared.apiroot}1.1/remove`, {idx: idx}).then((resp)=> {
        if(!resp || !resp.data) return alert(labels[shared.lang].error)
        if(resp.data.result == -1) return alert(labels[shared.lang].form_err_login)
        
        alert(labels[shared.lang].form_remove_success)
        this.$router.replace('/')
      }).catch(() => { alert(labels[shared.lang].error) })
    },
    
    initSocialTag() {
      document.title = labels[shared.lang].title
      document.querySelector('meta[property="og:title"]').setAttribute('content', document.title)
      document.querySelector('meta[property="og:image"]').setAttribute('content', `${shared.root}static/images/chocomint.png`)
      document.querySelector('meta[property="twitter:image"]').setAttribute('content', `${shared.root}static/images/chocomint.png`)
    },
  },
}
</script>

<style scoped>
form .form-btn-group {
  padding-top: 1rem;
  border-top: 1px #ccc solid;
}
</style>
